import { FC, useRef } from "react"
import { useLocation } from "react-router"
import { parse } from '~/utils/queryStringWrapper'
import authProvider, { CustomerIdPRedirectLoginInput } from "~/authProvider/authProvider"
import { raiseRouteOverwatchUsrProfile } from "~/actions/routeOverwatch"
import { useEffect } from "react"
import LayoutPlain from "./LayoutPlain"
import { Alert, Box, Card, CardContent, Typography } from "@mui/material"
import { useDispatch } from 'react-redux'
import { useSafeSetState } from "ra-core"
import NProgress from 'nprogress';
import { push } from "connected-react-router"
import { retrieveDeviceFlowInfo } from "./Device.common"


const bag: any = {}

const SsoRedirect: FC = (props) => {
  const dispatch = useDispatch()
  const queries = parse(useLocation().search)
  const queriesRef = useRef(queries)
  const [errMsg, setErrMsg] = useSafeSetState('')

  const pickQueries = (key: string) => {
    if (queriesRef.current[key]) {
      const qVal = queriesRef.current[key]
      return qVal instanceof Array ? qVal[0] : qVal
    } else {
      return undefined
    }
  }
  
  const error = pickQueries('err')
  const ssoProtocol = pickQueries('type')
  const username = pickQueries('username')
  const code = pickQueries('code')
  
  const loadingRef = useRef(false)
  useEffect(() => {
    if (error) {
      setErrMsg(error)

    } else if(username && code && ssoProtocol) {
      // !! somehow the effect invoked twice, which is real suprise, its not supposed to work like this.
      // this a potential hole, should be investigated later.
      const signature = JSON.stringify([error, username, code, ssoProtocol])
      if (!!bag[signature]) { return; }

      bag[signature] = true
      
      const deviceFlow = retrieveDeviceFlowInfo();
      const info: CustomerIdPRedirectLoginInput = {
        type: 'CustomerIdPRedirectLogin',
        username,
        code,
        ssoProtocol: ssoProtocol as any,
        deviceFlow,
      }
      NProgress.start()
      loadingRef.current = true

      authProvider.login(info).then(() => {
        NProgress.done()
        if (deviceFlow) {
          dispatch(push('/device-consent'))
        } else {
          dispatch(raiseRouteOverwatchUsrProfile())
        }
      }, (err) => {
        setErrMsg(err)
        NProgress.done()
      })
    } else {
  
      setErrMsg('Invalid SSO login attempt')
    }

    return () => {
      setTimeout(() => {
        for(var k in bag) {
          delete bag[k]
        }
      }, 2000)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <LayoutPlain>
      {!errMsg ? null :
      <Card>
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            p: 4
          }}
        >
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'space-between',
              mb: 3,
              maxWidth: 488,
            }}
          >
            <div>
              <Typography
                color="textPrimary"
                gutterBottom
                variant="h5"
              >
                Sign In Error
              </Typography>
            </div>
          </Box>
            <Alert severity="error">
              <Typography>
                {errMsg}
              </Typography>
            </Alert>
        </CardContent>
      </Card>
      }
    </LayoutPlain>
  )
}

export default SsoRedirect;
